import React, { useEffect, useState, useRef } from 'react';

const Timer = ({ timelimit, onTimeUp, text, paused = false }) => {
  const initialSeconds = Math.max(0, Math.floor(timelimit * 60));
  const [remainingTime, setRemainingTime] = useState(initialSeconds);
  const endTimeRef = useRef(Date.now() + initialSeconds * 1000);
  const onTimeUpCalledRef = useRef(false);
  const pausedRef = useRef(paused);
  const savedRemainingRef = useRef(null);

  // Xử lý chuyển đổi pause/unpause
  useEffect(() => {
    const wasPaused = pausedRef.current;
    pausedRef.current = paused;

    if (paused && !wasPaused) {
      savedRemainingRef.current = Math.max(0, Math.ceil((endTimeRef.current - Date.now()) / 1000));
    } else if (!paused && wasPaused && savedRemainingRef.current !== null) {
      endTimeRef.current = Date.now() + savedRemainingRef.current * 1000;
      savedRemainingRef.current = null;
      setRemainingTime(Math.max(0, Math.ceil((endTimeRef.current - Date.now()) / 1000)));
    }
  }, [paused]);

  useEffect(() => {
    const initial = Math.max(0, Math.floor(timelimit * 60));
    const endTime = Date.now() + initial * 1000;
    endTimeRef.current = endTime;
    onTimeUpCalledRef.current = false;
    savedRemainingRef.current = null;
    setRemainingTime(initial);

    if (initial <= 0) return;

    const updateRemaining = () => {
      if (pausedRef.current) return;
      const remaining = Math.max(0, Math.ceil((endTimeRef.current - Date.now()) / 1000));
      setRemainingTime(remaining);
    };

    const intervalId = setInterval(updateRemaining, 1000);

    const handleVisibilityChange = () => {
      if (!document.hidden && !pausedRef.current) {
        updateRemaining();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [timelimit]);

  useEffect(() => {
    if (remainingTime <= 0 && !onTimeUpCalledRef.current) {
      onTimeUpCalledRef.current = true;
      onTimeUp();
    }
  }, [remainingTime, onTimeUp]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const isCompleted = remainingTime <= 0;

  const bgGradient = isCompleted
    ? 'linear-gradient(135deg, #ecfdf5, #d1fae5)'
    : paused
    ? 'linear-gradient(135deg, #fefce8, #fef9c3)'
    : 'linear-gradient(135deg, #eff6ff, #dbeafe)';
  const borderColor = isCompleted ? '#6ee7b7' : paused ? '#fcd34d' : '#93c5fd';
  const textColor = isCompleted ? '#065f46' : paused ? '#92400e' : '#1e40af';
  const timeColor = isCompleted ? '#059669' : paused ? '#b45309' : '#1d4ed8';

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 14px',
        borderRadius: 50,
        background: bgGradient,
        border: `1.5px solid ${borderColor}`,
        transition: 'all 0.3s ease',
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 600, color: textColor }}>
        {isCompleted ? 'Đã hoàn thành' : paused ? 'Tạm dừng' : (text || '⏱ Còn')}
      </span>
      {!isCompleted && (
        <span
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: timeColor,
          }}
        >
          {formatTime(remainingTime)}
        </span>
      )}
    </div>
  );
};

export default Timer;
